import { orderPrintingConfigService } from 'components/settings-options-and-extensions/components/order-printing-config/infra';
import { featureAdoptionService } from 'shared/services/feature-adoption';
import OrdersUtils from 'utils/OrdersUtils';
import { FeatureAdoptionTypes } from '../domain';

import type { AdoptionData } from '../domain';
import type { PartnerId } from 'shared/domain';
import type { OrderDetailStateRedux } from 'shared/infra/redux';

export function orderDetailAdoptionService(
  currentOrder: OrderDetailStateRedux,
) {
  const _isNewOrder = OrdersUtils.isNew(currentOrder?.partner_order_state);
  const _showPrinter = !(
    _isNewOrder && OrdersUtils.isMarketPlace(currentOrder?.delivery_method)
  );
  const _STORAGE_ITEM_NAME = 'order_detail_adoption';
  const storeId = currentOrder?.store_id;
  const partnerId: PartnerId = currentOrder?.partner_id;
  const hasHandoff = Boolean(currentOrder?.qr_information) && !_isNewOrder;
  const isPrintUnset =
    !orderPrintingConfigService().getOrderPrintingConfig().command &&
    _showPrinter &&
    !_isNewOrder;
  const isNewUser = currentOrder?.detail?.user?.is_new_user && !_isNewOrder;
  const isHighValueUser =
    currentOrder?.detail?.user?.high_value_user && !_isNewOrder;
  const {
    MAX_VIEWS,
    getStoredData,
    hasDayElapsed,
    initialAdoptionValue,
    updateStoredData,
  } = featureAdoptionService<FeatureAdoptionTypes>({
    storageItemName: _STORAGE_ITEM_NAME,
  });

  const addInitialStoredData = () => {
    const initialValues: Record<FeatureAdoptionTypes, AdoptionData> = {
      [FeatureAdoptionTypes.ScalePrinted]: initialAdoptionValue(
        FeatureAdoptionTypes.ScalePrinted,
      ),
      [FeatureAdoptionTypes.handoff]: initialAdoptionValue(
        FeatureAdoptionTypes.handoff,
      ),
    };

    const storedData: AdoptionData[] = [
      ...(isPrintUnset
        ? [initialValues[FeatureAdoptionTypes.ScalePrinted]]
        : []),
      ...(hasHandoff ? [initialValues[FeatureAdoptionTypes.handoff]] : []),
    ];

    if (storedData.length > 0) {
      localStorage.setItem(_STORAGE_ITEM_NAME, JSON.stringify(storedData));
    }
  };

  const addStoredData = (type: FeatureAdoptionTypes) => {
    const storedData = getStoredData();

    const initialValues: Record<
      FeatureAdoptionTypes,
      ReturnType<typeof initialAdoptionValue>
    > = {
      [FeatureAdoptionTypes.ScalePrinted]: initialAdoptionValue(
        FeatureAdoptionTypes.ScalePrinted,
      ),
      [FeatureAdoptionTypes.handoff]: initialAdoptionValue(
        FeatureAdoptionTypes.handoff,
      ),
    };

    const valueToAdd = initialValues[type];
    if (valueToAdd !== undefined) {
      storedData.push(valueToAdd);
    }

    localStorage.setItem(_STORAGE_ITEM_NAME, JSON.stringify(storedData));
  };

  return {
    getStoredData,
    updateStoredData,
    hasDayElapsed,
    addInitialStoredData,
    addStoredData,
    hasHandoff,
    isPrintUnset,
    MAX_VIEWS,
    storeId,
    partnerId,
  };
}
